import { useState } from "react";
import { navItems, tickerItems } from "@/mocks/leakData";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <header className="relative z-40">
      {/* 顶部快讯滚屏带 */}
      <div className="bg-foreground-950 text-background-50">
        <div className="mx-auto flex h-9 max-w-7xl items-center gap-3 px-4 md:px-6">
          <span className="hidden shrink-0 items-center gap-1.5 rounded-sm bg-primary-600 px-2 py-0.5 text-[11px] font-bold tracking-widest text-background-50 sm:flex">
            <i className="ri-flashlight-fill text-[12px]" />
            实时快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-marquee flex w-max items-center whitespace-nowrap">
              {doubled.map((item, i) => (
                <a
                  key={i}
                  href="#express"
                  className="mx-6 flex items-center gap-2 text-xs leading-none text-background-100/80 transition hover:text-accent-300"
                >
                  <span className="h-1 w-1 rounded-full bg-accent-400" />
                  {item}
                </a>
              ))}
            </div>
          </div>
          <span className="hidden shrink-0 items-center gap-1.5 text-xs text-background-100/60 lg:flex">
            <span className="relative flex h-2 w-2">
              <span className="animate-pulse-dot absolute inline-flex h-full w-full rounded-full bg-primary-400" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
            </span>
            信源在线 · 采访中
          </span>
        </div>
      </div>

      {/* 主导航 */}
      <div className="border-b border-background-200/80 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
          <a href="#headline" className="flex items-center gap-3 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 font-heading text-xl font-black text-background-50">
              98
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                98<span className="text-primary-600">爆料</span>
              </span>
              <span className="mt-1 text-[10px] tracking-[0.28em] text-secondary-500">
                独家消息 · 第一手内幕
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((n) => (
              <a
                key={n.label}
                href={n.href}
                className="rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition hover:bg-background-100 hover:text-primary-600"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#submit"
              className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-700 sm:inline-flex"
            >
              <i className="ri-speak-line" />
              匿名投稿
            </a>
            <button
              onClick={() => setOpen(!open)}
              aria-label="菜单"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-background-200/80 bg-background-50 px-4 py-3 lg:hidden">
            <div className="flex flex-col gap-1">
              {navItems.map((n) => (
                <a
                  key={n.label}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition hover:bg-background-100"
                >
                  {n.label}
                </a>
              ))}
              <a
                href="#submit"
                onClick={() => setOpen(false)}
                className="mt-1 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-600 px-4 py-2.5 text-sm font-semibold text-background-50"
              >
                <i className="ri-speak-line" />
                匿名投稿
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}